<template>
  <v-bottom-sheet v-model="isActive" persistent>
    <div class="bottom-sheet-content">
      <div class="bottom-sheet-header">
        <span class="bottom-sheet-title">Detalhes do áudio</span>
        <v-btn icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <div class="created-by mt-4" v-if="audioToEdit.created_by_user">
        <div class="initial">{{ audioToEdit.created_by_user.name.charAt(0).toUpperCase() }}</div>
        <div class="details">
          <span class="name">{{ audioToEdit.created_by_user.name }}</span>
          <span class="date">{{ formatDateTime(audioToEdit.created_at) }}</span>
        </div>
      </div>
      <v-divider></v-divider>
      <v-textarea class="mt-4" v-model="audioToEdit.observation" label="Observações" outlined clearable hide-details :disabled="user?.role?.name === 'operational'"></v-textarea>
      <div v-if="audioToEdit.updated_by_user" class="mt-2 mb-4">
        <small>Alterado pela última vez por {{ handleObservation(audioToEdit.updated_by_user) }} em {{ new Date(audioToEdit.updated_at).toLocaleDateString() }} às {{ new Date(audioToEdit.updated_at).toLocaleTimeString() }}</small>
      </div>
      <v-switch
        v-model="audioToEdit.visible"
        label="Áudio visível para o cliente"
        color="primary"
        :disabled="user?.role?.name === 'operational'"
      ></v-switch>
      <v-divider class="mb-4"></v-divider>
      <div class="actions d-flex justify-space-between">
        <v-btn class="mt-2" color="red" outlined @click="remove" elevation="0" :disabled="user?.role?.name === 'operational'">Excluir</v-btn>
        <v-btn class="mt-2" color="primary" @click="save" elevation="0" :disabled="user?.role?.name === 'operational'">Salvar</v-btn>

      </div>
    </div>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'AudioDetails',
  emits: ['close', 'save', 'remove'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      audioToEdit: {
        observation: '',
        visible: true,
      },
      user: null,
    };
  },
  watch: {
    audio: {
      handler(newVal) {
        this.audioToEdit = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
    },
  },
  mounted() {
    this.user = this.$store.getters['Auth/user'];
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', this.audioToEdit);
    },
    remove() {
      this.$emit('remove', this.audioToEdit);
    },
    handleObservation(user) {
      const loggedUser = this.$store.getters['Auth/user'];

      if (loggedUser.id === user.id) {
        return 'você';
      }

      return user.name;
    },
    formatDateTime() {
      const date = new Date(this.audio.created_at);

      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      if (date.toDateString() === today.toDateString()) {
        return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      }

      if (date.toDateString() === yesterday.toDateString()) {
        return `Ontem às ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
      }

      if (date.getFullYear() === today.getFullYear()) {
        return date.toLocaleDateString('pt-BR', { month: 'long', day: 'numeric' }) + ' às ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      }

      return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' }) + ' às ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    },
  }
};
</script>

<style lang="scss" scoped>
.bottom-sheet-content {
  padding: 16px;

  .bottom-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .bottom-sheet-title {
      font-size: 18px;
      font-weight: 500;
    }
  }
}

.created-by {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .initial {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    margin-right: 16px;
    cursor: pointer;
  }

  .details {
    display: flex;
    flex-direction: column;

    .name {
      font-size: 16px;
      font-weight: 500;
    }

    .date {
      font-size: 14px;
      color: #666;
    }
  }
}
</style>
